
<template>
  <div>
    <v-dialog v-model="dialog" persistent max-width="460px" transition="dialog-transition">
      <v-card v-if="dialog" class="pix-dialog-card">
        <div class="pix-dialog-header d-flex align-center px-5 py-4">
          <v-icon color="white" class="mr-3">mdi-qrcode</v-icon>
          <div>
            <div class="text-h6 white--text font-weight-bold">{{ isCobranca ? 'PIX Cobrança' : 'PIX' }}</div>
            <div class="caption white--text" style="opacity:.85">Escaneie o QR code ou use o Pix Copia e Cola</div>
          </div>
          <v-spacer></v-spacer>
          <v-btn icon dark small @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
        </div>
        <v-card-text class="pt-5 pb-2">
          <pix-qr-card :pix="item"></pix-qr-card>
        </v-card-text>
        <v-card-actions class="px-5 pb-4">
          <v-spacer></v-spacer>
          <v-btn text color="grey darken-1" @click="dialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import PixQrCard from './PixQrCard.vue'

export default {
  name: 'DialogPix',
  components: {
    PixQrCard
  },
  props: {
    item: {
      type: Object,
    }
  },
  data() {
    return {
      dialog: true
    }
  },
  computed: {
    isCobranca() {
      return this.item && this.item.gateway_provider === 'sicoob_pix_cobranca'
    },
  },
  watch: {
    dialog(nv) {
      if (nv == false){
        this.$emit('close')
      }
    }
  },
}
</script>

<style scoped>
.pix-dialog-card {
  border-radius: 16px !important;
  overflow: hidden;
}
.pix-dialog-header {
  background: linear-gradient(135deg, #00695c 0%, #26a69a 100%);
}
</style>
